// frontend/src/analytics.js
export const trackPageview = (path) => {
  // Helpful for local debugging — remove if you want
  // console.log('[GA] page_view:', path);

  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
};

export const trackEvent = ({ action, category, label, value }) => {
  // console.log('[GA] event:', action, category, label, value);

  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
};
